import { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { Dropdown, Popover, SideSheet, Tree } from "@douyinfe/semi-ui";
import { IndexContext } from "@/stores";
import classNames from "classnames";
import { useRouter } from "next/router";
import searchNode from "@/utils/searchNode";
import { useTranslations } from "next-intl";

export interface INavBarProps {
}

export type NavType = {
  id: number,
  parent: number,
  name: string,
  path: string,
  out_link: string,
  children: NavType[]
}

interface RenderLabelProps {
  className?: string;
  onExpand?: any;
  onClick?: any;
  data: any;
  expandIcon?: React.ReactNode;
}

export const NavBar: FC<INavBarProps> = () => {
  const router = useRouter()
  const [isExpand, setIsExpand] = useState<boolean>(false)
  const [active, setActive] = useState<number>(0)
  const nowRef = useRef<any>()
  const { nav, getNav, webInfo, isBecome } = useContext(IndexContext);
  const t = useTranslations();

  const changeLanguage = (locale: any) => {
    router.push(router.pathname, router.asPath, { locale });
    getNav(locale)
  };

  const navTo = useCallback((e: any, item: NavType): void => {
    e.stopPropagation && e.stopPropagation();

    if (router.asPath == item.path) {
      return
    }
    setIsExpand(false)
    if (item.out_link) {
      const a = document.createElement("a")
      a.href = item.out_link
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()

      document.body.removeChild(a)
      return
    }
    if (!item.children.length) {

      router.push(item.path)
      // const parent = nav.find(nav =>
      //   nav.id === item.parent
      // ) as NavType
      return
    }

    router.push(item.children[0].path)
    // !item.children.length &&
  }, [nav, isExpand, router])

  const transSelectData = useCallback((tree: any) => {
    return tree?.map((item: any) => {
      const { id, name, title, children, path } = item;
      const transformedChildren = children?.length
        ? transSelectData(children)
        : [];
      return {
        value: id,
        label: name,
        key: id + '',
        path,
        children: transformedChildren.map((child: any) => {
          return {
            ...child,
          };
        }),
      };
    });
  }, [nav, router.locale]);

  const renderLabel: React.FC<RenderLabelProps> = ({
    className,
    onExpand,
    onClick,
    data,
    expandIcon,
  }) => {
    const { label } = data;
    const isLeaf = !(data.children && data.children.length);
    return (
      <li
        className={className}
        role="treeitem"
        onClick={isLeaf ? onClick : onExpand}
      >
        {isLeaf ? null : expandIcon}
        <span>{label}</span>
      </li>
    );
  }; 

  const calculateDaysDifference = useMemo(() => {
    const now = Date.now();

    console.log("webInfo", webInfo)

    if (webInfo) {
      const open = webInfo
        ?.find((item: any) => item.code === 'exhibition_start_time')
        ?.content;

      const differenceInMs = open - now
      console.log("open", open)
      console.log("now", now)
      const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

      return Math.max(differenceInDays, 0);
    }
    return 0
  }, [webInfo]);

  useEffect(() => {
    const act = searchNode(nav, router.asPath)
    setActive(act?.parent)
    nowRef.current = act?.parent
  }, [nav, router])

  return (
    <div className={styles.header}>
      <a href="/" className={styles.logo}>
        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/logo.png" alt="" />
      </a>

      {/* {isBecome ?
        <div className={styles.btns}>
          <a href="/">{t('common.backHome')}</a>
        </div>
        : <> */}
      <ul className={classNames([styles.nav, 'minHidden'])}>
        {
          !!nav &&
          nav.map((item: any) => (
            <Popover
              showArrow
              style={{ display: item.children.length ? 'block' : 'none' }}
              content={
                <div className={classNames([styles.childList])}>
                  <div>
                    <div className={styles.right}>
                      <ul>
                        {
                          item.children.map((child: any) => (
                            <li style={{ fontSize: '18px' }} key={child.id as any} onClick={(e) => navTo(e, child)}>
                              {child.name}
                              {/* <span>{'>'}</span> */}
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              }
              position='bottom'
              key={item.id}
              onVisibleChange={(isVis) => {
                setActive(isVis ? item.id : nowRef.current)
              }}
            >
              <li
                className={classNames({ [styles.active]: active === item.id })}
                onClick={(e) => navTo(e, item)}
                style={{ fontSize: '18px' }}
              >
                <div className={styles.parentItem}>
                  {item.name}
                </div>
              </li>
            </Popover>
          ))
        }
      </ul>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Dropdown
          style={{ width: '176px' }}
          render={
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => changeLanguage('cn')}>中文</Dropdown.Item>
              <Dropdown.Item onClick={() => changeLanguage('en')}>English</Dropdown.Item>
            </Dropdown.Menu>
          }
        >
          <div className={styles.langs}>
            {router.locale === 'cn' ? '语言：中文' : 'English'}
          </div>
        </Dropdown>

      </div>
      <div className={classNames([styles.count])}>
        {t('common.cout')}<span>{calculateDaysDifference}</span>{t('common.day')}
      </div>
      {/* </>} */}

      <div className={classNames([styles.expand, 'minShow'])} onClick={() => setIsExpand(!isExpand)}>
        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/menu.png" alt="" />
      </div>
      <SideSheet title="IPB 2026" width={'75%'} visible={isExpand} onCancel={() => setIsExpand(!isExpand)} placement="left">
        <Tree
          treeData={transSelectData(nav)}
          renderFullLabel={renderLabel}
          onSelect={(selectedKey, selected, selectedNode) => {
            navTo({}, selectedNode as any)
          }}
        />
      </SideSheet>
      <style jsx global lang='scss'>
        {
          `
            .semi-sidesheet-title{
              width:80%;
              font-size:30px;
            }
            .semi-sidesheet .semi-tree-option{
              padding:8px 12px !important;
            }
            .semi-dropdown-item{
              justify-content:center;
            }
          `
        }
      </style>
    </div >
  );
};
